import facade640 from './image2-640.webp'
import facade1280 from './image2-1280.webp'
import facade1920 from './image2-1920.webp'
import jacuzzi640 from './image1-640.webp'
import jacuzzi1280 from './image1-1280.webp'
import jacuzzi1920 from './image1-1920.webp'
import produits640 from './image3-640.webp'
import produits1280 from './image3-1280.webp'
import produits1920 from './image3-1920.webp'

/*
 * Les trois photographies livrées avec le code, chacune en trois largeurs
 * (issue #142).
 *
 * Elles étaient servies en pleine résolution à tout le monde : 5 Mo pour la
 * seule page d'accueil, et un téléphone de 390 points téléchargeant une image
 * de 2816 pixels. PageSpeed mesurait un LCP mobile de 15,2 s.
 *
 * Les déclinaisons sont produites par `scripts/genererVisuelsAccueil.mjs`
 * depuis les originaux, restés dans ce dossier sans être importés — webpack
 * n'embarque que ce qu'on lui demande. Relancer le script après toute
 * modification d'une source ou des largeurs.
 *
 * Le `src` désigne la déclinaison de 1280 : c'est ce que reçoit un navigateur
 * qui ignore `srcset`, et le milieu de gamme est le moins mauvais des choix
 * par défaut — 640 serait flou sur un écran d'ordinateur, 1920 gâcherait la
 * bande passante d'un téléphone.
 */

function declinaisons(paliers) {
  return paliers.map(([url, largeur]) => `${url} ${largeur}w`).join(', ')
}

export const PHOTO_FACADE = {
  src: facade1280,
  srcSet: declinaisons([
    [facade640, 640],
    [facade1280, 1280],
    [facade1920, 1920],
  ]),
  alt: "Façade de l'institut Azoya Spa",
}

export const PHOTO_JACUZZI = {
  src: jacuzzi1280,
  srcSet: declinaisons([
    [jacuzzi640, 640],
    [jacuzzi1280, 1280],
    [jacuzzi1920, 1920],
  ]),
  alt: 'Jacuzzi et hammam privatif',
}

export const PHOTO_PRODUITS = {
  src: produits1280,
  srcSet: declinaisons([
    [produits640, 640],
    [produits1280, 1280],
    [produits1920, 1920],
  ]),
  alt: 'Produits Baïja disponibles à l’institut',
}
